module.exports = __webpack_public_path__ + "img/house_lock.777c68c.svg";